export default __webpack_public_path__ + "static/media/pic04.cff9dc15.jpg";